<template>
    <student-backend-focus-layout
        header-bg-color="white"
        content-bg-color="gray-125"
        exit-button-text="Exit to dashboard"
        v-on:exit-page-clicked="exitToDashboard"
        :page-title="pageTitle"
    >
        <template #page_header>
            <div class="flex flex-col gap-8 py-8">
                <div class="">
                    <Link
                        :href="
                            route(
                                'student.computer-adaptive-test.show-cat-review',
                                {
                                    cat_attempt: catAttempt.id,
                                }
                            )
                        "
                        class="rounded border border-gray-600 p-2 text-gray-600 hover:cursor-pointer hover:bg-gray-600/10"
                    >
                        Back to Results
                    </Link>
                </div>
                <div class="flex items-center gap-4">
                    <div class="font-semibold">
                        {{ focusArea.title }}
                    </div>
                    <div class="text-gray-600">
                        ({{ focusAreaPerformance.correct }}/
                        {{ focusAreaPerformance.attempted }})
                    </div>
                    <div class="">
                        <span
                            v-if="
                                focusAreaPerformance.result == 'FINISHED-PASSED'
                            "
                            class="inline-block w-14 rounded border border-green-400 px-2 py-1 text-center font-medium text-green-400"
                        >
                            Pass
                        </span>
                        <span
                            v-else
                            class="inline-block w-14 rounded border border-red-500 px-2 py-1 text-center font-medium text-red-500"
                            >Fail</span
                        >
                    </div>
                </div>
            </div>
        </template>
        <template #content>
            <div class="relative mx-auto flex">
                <div class="flex flex-col gap-4">
                    <template v-for="(question, index) in questions">
                        <StudentQuizReviewQuestion
                            :question="question"
                            :question-number="index + 1"
                        />
                    </template>
                </div>

                <div
                    class="absolute -right-16 bottom-0 hidden text-gray-600 hover:cursor-pointer hover:text-gray-925 md:block"
                    @click="scrollToTop()"
                >
                    <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M24 29.8337V18.167"
                            stroke="currentColor"
                            stroke-width="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M18.167 24.0003L24.0003 18.167L29.8337 24.0003"
                            stroke="currentColor"
                            stroke-width="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <circle
                            cx="24"
                            cy="24"
                            r="23.5"
                            stroke="currentColor"
                        />
                    </svg>
                </div>
            </div>
        </template>
    </student-backend-focus-layout>
</template>

<script>
import StudentBackendFocusLayout from "@/_Layouts/NewStudentBackendFocusLayout.vue";
import StudentQuizQuestionAnswer from "@/Components/StudentQuizQuestionAnswer.vue";
import ConfirmDialog from "@/Components/ConfirmDialog.vue";
import dayjs from "dayjs";
import StudentQuizReviewQuestion from "@/Pages/NewStudentBackend/StudentQuizReviewQuestion.vue";

export default {
    name: "StudentComputerAdaptiveTestReview",
    components: {
        StudentQuizReviewQuestion,
        ConfirmDialog,
        StudentQuizQuestionAnswer,
        StudentBackendFocusLayout,
    },
    props: {
        catAttempt: {
            type: Object,
            default: {},
        },
        focusAreaPerformance: {
            type: Object,
            default: {},
        },
        focusArea: {
            type: Object,
            default: {},
        },
        questions: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {};
    },
    methods: {
        dayjs,
        scrollToTop: function () {
            window.scrollTo(0, 0);
        },
        exitToDashboard: function () {
            this.$inertia.get(route("student.dashboard"));
        },
        getFocusArea(focusAreaId) {
            let focusArea = _.find(
                this.$page.props.focusAreas,
                function (focusArea) {
                    return focusArea.id == focusAreaId;
                }
            );

            return focusArea;
        },
    },
    computed: {
        pageTitle() {
            return (
                "Computer Adaptive Test Review - " +
                this.$page.props.auth.user.provider_level.title
            );
        },
        quizStartTime() {
            return dayjs(this.catAttempt.started_at);
        },
        quizEndTime() {
            return dayjs(this.catAttempt.completed_at);
        },
    },
    mounted() {},
};
</script>

<style scoped></style>
